import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrmServiceService } from '../../../../service/crm-service.service';
import { AddMeetingParticipantsComponent } from '../add-meeting-participants/add-meeting-participants.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DbService } from 'src/app/services/db-service/db.service';
import { Observable, map, startWith, of, catchError, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { TemplateService } from 'src/app/services/template.service';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';
import { MapService } from 'src/app/services/map.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { PricingDetailsComponent } from 'src/app/shared-module-files/components/pricing-details/pricing-details.component';
import moment from 'moment';
import { StaffAccessServiceService } from '../../../../crm-config/staff-access/staff-access-service.service';
import { ActivatedRoute } from '@angular/router';
import { EcommerceService } from 'src/app/services/ecommerce.service';
import { StaffServiceService } from 'src/app/master-config-components/micro-apps/staff/service/staff-service.service';
import { CrmLabel } from '../../../../crm-models';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
  }
};
@Component({
  selector: 'app-create-meeting',
  templateUrl: './create-meeting.component.html',
  styleUrls: ['./create-meeting.component.scss', './mq-create-meeting.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    DatePipe
  ]
})
export class CreateMeetingComponent implements OnInit {
  selectedLabelIds: string[] = [];
  selectedLabels: CrmLabel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreateMeetingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private crmService: CrmServiceService,
    private snackbar: MatSnackBar,
    private dbService: DbService,
    private templateService: TemplateService,
    private mapService: MapService,
    private snackBar: MatSnackBar,
    private activate: ActivatedRoute,
    private ecommerceService: EcommerceService,
    private staffAccessService: StaffAccessServiceService,
    private staffService: StaffServiceService
  ) {
    this.getScreenSize();
  }
  async ngOnInit() {

    this.isStaffAdmin = this.staffService.isStaffAdmin();

    await this.getAllPipelines();
    this.activate.queryParams.subscribe((qp: any) => {
      if (qp != null) {
        this.getLeadDetails(qp.leadId);
      }
    })

    if (this.data.data.creationType == 'RECORD') {
      const date = new Date();
      this.meetDetails.startDateTime = date;
      this.onStartDateChange();
    }

    if (this.data?.data?.leadId) {
      this.meetDetails.leadId = this.data?.data?.leadId;
      this.meetDetails.leadName = this.data?.data?.leadName
      this.meetDetails.leadNumber = this.data?.data?.leadNumber;
    }

    if (!this.data.data.edit) {
      this.fetchStores();
    }

    if (this.data.data.creatingIn) {
      this.meetDetails.meetingStatus = this.data.data.creatingIn
    }
    else {
      this.meetDetails.meetingStatus = 'SCHEDULED'
    }


    if (this.data.data.edit && this.data.data.type !== 'ACTIVITY') {
      this.meetDetails = JSON.parse(JSON.stringify(this.data.data.data));
      this.meetDetails.startDateTime = new Date(this.meetDetails.startDateTime);
      this.meetDetails.endDateTime = new Date(this.meetDetails.endDateTime);
      this.meetDetails.endDateTime.setHours(this.meetDetails.endDateTime.getHours() + 5);
      this.meetDetails.endDateTime.setMinutes(this.meetDetails.endDateTime.getMinutes() + 30);
      this.meetDetails.startDateTime.setHours(this.meetDetails.endDateTime.getHours() + 5);
      this.meetDetails.startDateTime.setMinutes(this.meetDetails.endDateTime.getMinutes() + 30);
      this.originalStartDate = new Date(this.meetDetails.startDateTime);
      this.getStartTime(this.meetDetails.startDateTime);
      this.getEndTime(this.meetDetails.endDateTime)
      this.filterTimes();
      this.selectedLabelIds = [...(this.meetDetails.labelIds || [])];
      this.selectedLabels = [...(this.meetDetails.labels || [])];
    }
    if (this.data.data.type == 'ACTIVITY' && this.data.data.edit) {
      this.getMeetingById()
      this.meetDetails.startDateTime = new Date(this.meetDetails.startDateTime);
      this.meetDetails.endDateTime = new Date(this.meetDetails.endDateTime);
      this.meetDetails.endDateTime.setHours(this.meetDetails.endDateTime.getHours() + 5);
      this.meetDetails.endDateTime.setMinutes(this.meetDetails.endDateTime.getMinutes() + 30);
      this.meetDetails.startDateTime.setHours(this.meetDetails.endDateTime.getHours() + 5);
      this.meetDetails.startDateTime.setMinutes(this.meetDetails.endDateTime.getMinutes() + 30);
      this.originalStartDate = new Date(this.meetDetails.startDateTime);
      this.getStartTime(this.meetDetails.startDateTime);
      this.getEndTime(this.meetDetails.endDateTime)
      this.filterTimes();
    }
    if (this.staffList.length <= 0) {
      this.getStaffListing();
    }

    if (this.data.data.edit && this.data.data.type === 'ALL_MEETINGS') {
      this.meetDetails = JSON.parse(JSON.stringify(this.data.data.data));
      this.meetDetails.locationType = this.data.data.data?.storeId ? 'BUSINESS_LOCATION' : 'CLIENT_LOCATION';
      if (this.meetDetails.locationType == 'BUSINESS_LOCATION') {
        this.fetchStores();
      }
      this.originalStartDate = new Date(this.meetDetails.startDateTime);
      this.meetDetails.startDateTime = new Date(this.meetDetails.startDateTime);
      this.meetDetails.endDateTime = new Date(this.meetDetails.endDateTime);
      this.selectedContact = this.meetDetails.leadName;
      this.selectedLabelIds = [...(this.meetDetails.labelIds || [])];
      this.selectedLabels = [...(this.meetDetails.labels || [])];
      this.getLeadDetails(this.meetDetails.leadId);
    }


    if (this.meetDetails.meetingType === 'VIRTUAL') {
      this.originalStartDate = new Date(this.meetDetails.startDateTime);
      this.meetDetails.meetingLink = this.data?.data?.meetDetails?.meetingLink ?? "";
    } else {
      if (localStorage.getItem(StorageKeys.LOCALITY)) {
        this.meetDetails.meetingLocated =
          `${localStorage.getItem(StorageKeys.LOCALITY)}` + ',' + `${localStorage.getItem(StorageKeys.STATE)}`
      }
      else {
        this.meetDetails.meetingLocated = ''
      }

      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '')),
      );

    }
    this.getdata();

  }

  isStaffAdmin: boolean = false;

  screenWidth: number = 0;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.screenWidth = window.innerWidth;
    // 
  }

  minDate: Date = new Date();
  leadIdPipelineId: string = ''
  participantType: any = "LEAD"
  type = [
    { value: "LEAD", viewValue: "Leads" },
    { value: "CUSTOMER", viewValue: "Customers" }
  ]
  options: any[] = [];
  filteredOptions: Observable<any> | undefined;
  myControl = new FormControl('');
  selectedContact = "";
  listPipelines: any[] = [];
  pipelineStages: any[] = [];
  selectedPipelineId: string = '';
  selectedStageId: string = '';
  pipelineSelected: boolean = false;

  // --- Desktop (screenWidth > 475) rebuild: dropdown state machine + wrappers.
  // Mobile keeps using the fields/methods below untouched (callStartTime,
  // filteredStartTimeArray, onStartDateChange, etc.) — these wrappers just
  // drive the same state through the new .field-dd / CustomCalendarComponent UI.
  openDropdown: 'meetingLocation' | 'store' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'status' | 'reminder' | 'participantType' | 'contact' | 'assignedTo' | 'participantsReminder' | 'birthday' | 'anniversary' | null = null;

  toggleDropdown(name: 'meetingLocation' | 'store' | 'startDate' | 'endDate' | 'startTime' | 'endTime' | 'status' | 'reminder' | 'participantType' | 'assignedTo' | 'participantsReminder' | 'birthday' | 'anniversary'): void {
    this.openDropdown = this.openDropdown === name ? null : name;
  }

  openContactDropdown(): void {
    this.openDropdown = 'contact';
  }

  closeDropdowns(): void {
    this.openDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDropdownDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.field-dd')) {
      this.closeDropdowns();
    }
  }

  trackByOptionValue(_index: number, item: any): string {
    return item.value ?? item.id;
  }

  setMeetingType(value: string): void {
    this.meetDetails.meetingType = value;
    this.changeMeetingType();
  }

  setLocationType(value: string): void {
    this.meetDetails.locationType = value;
    this.changeLocationType();
  }

  openMeetingLocationDropdown(): void {
    this.openDropdown = 'meetingLocation';
  }

  selectMeetingLocation(option: any): void {
    this.selectedLocations(option);
    this.meetDetails.meetingLocated = option.displayName;
    this.closeDropdowns();
  }

  selectStore(item: any): void {
    this.meetDetails.storeId = item.id;
    this.onStoreChange();
    this.closeDropdowns();
  }

  getStoreLabel(): string {
    return this.storeList.find(s => s.id === this.meetDetails.storeId)?.storeName || 'Select Store';
  }

  startDateAsDate: Date | null = null;
  endDateAsDate: Date | null = null;
  minEndDateAsDate: Date | null = null;

  openStartDatePicker(): void {
    this.startDateAsDate = this.meetDetails.startDateTime ? new Date(this.meetDetails.startDateTime) : null;
    this.toggleDropdown('startDate');
  }

  getStartDateLabel(): string {
    if (!this.meetDetails.startDateTime) return 'DD/MM/YYYY';
    return new Date(this.meetDetails.startDateTime).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  onStartDateApplied(date: Date): void {
    this.meetDetails.startDateTime = date;
    this.onStartDateChange();
    this.closeDropdowns();
  }

  openEndDatePicker(): void {
    if (this.allDayCheckbox) return;
    this.endDateAsDate = this.meetDetails.endDateTime ? new Date(this.meetDetails.endDateTime) : null;
    this.minEndDateAsDate = this.meetDetails.startDateTime ? new Date(this.meetDetails.startDateTime) : null;
    this.toggleDropdown('endDate');
  }

  getEndDateLabel(): string {
    if (!this.meetDetails.endDateTime) return 'DD/MM/YYYY';
    return new Date(this.meetDetails.endDateTime).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  onEndDateApplied(date: Date): void {
    this.meetDetails.endDateTime = date;
    this.onEndDateChange();
    this.closeDropdowns();
  }

  selectStartTime(item: any): void {
    if (item.isDisabled) return;
    this.callStartTime = item.viewValue;
    this.onStartTimeChange();
    this.closeDropdowns();
  }

  selectEndTime(item: any): void {
    if (item.isDisabled) return;
    this.callEndTime = item.viewValue;
    this.onEndTimeChange();
    this.closeDropdowns();
  }

  selectStatus(value: string): void {
    this.meetDetails.meetingStatus = value;
    this.closeDropdowns();
  }

  getStatusLabel(): string {
    return this.status.find(s => s.value === this.meetDetails.meetingStatus)?.viewValue || 'Select';
  }

  selectReminder(value: number): void {
    this.meetDetails.remainder = value;
    this.closeDropdowns();
  }

  getReminderLabel(): string {
    return this.reminder.find(r => r.value === this.meetDetails.remainder)?.viewValue || 'Select';
  }

  selectParticipantsReminder(value: number): void {
    this.meetDetails.participantsRemainder = value;
    this.closeDropdowns();
  }

  getParticipantsReminderLabel(): string {
    return this.reminder.find(r => r.value === this.meetDetails.participantsRemainder)?.viewValue || 'Select';
  }

  selectParticipantType(value: string): void {
    this.participantType = value;
    this.getdata();
    this.closeDropdowns();
  }

  getParticipantTypeLabel(): string {
    return this.type.find(t => t.value === this.participantType)?.viewValue || 'Select';
  }

  selectAssignedTo(staff: any): void {
    if (staff) {
      this.meetDetails.assignedTo = staff.id;
      this.meetDetails.assignedName = staff.name;
    }
    this.closeDropdowns();
  }

  get scheduleFormInvalid(): boolean {
    return !this.meetDetails?.title || !this.meetDetails?.startDateTime || !(this.callStartTime || this.allDayCheckbox) || this.visitTypeValidation();
  }

  get recordCreateDisabled(): boolean {
    return !this.meetDetails.leadName || !this.meetDetails.leadNumber;
  }

  get recordEditDisabled(): boolean {
    return !this.meetDetails?.title || !this.meetDetails?.startDateTime || !this.callStartTime || (!this.meetDetails.participantsList.length && !this.meetDetails.emailData.length);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option?.personalInfo?.name?.toLowerCase().includes(filterValue) || option?.personalInfo?.mobile?.includes(filterValue));
  }


  priorityList = [
    { value: "NONE", viewValue: "None" },
    { value: "HIGH", viewValue: "High" },
    { value: "MEDIUM", viewValue: "Medium" },
    { value: "LOW", viewValue: "Low" },
  ]

  status = [
    { value: "NEW", viewValue: "New" },
    { value: "SCHEDULED", viewValue: "Scheduled" },
    { value: "IN_PROGRESS", viewValue: "In progress" },
    { value: "COMPLETED", viewValue: "Completed" },
    { value: "CANCELLED", viewValue: "Cancelled" },
    { value: "RESCHEDULED", viewValue: "Rescheduled" },
  ]

  reminder = [
    { value: 0, viewValue: 'No Reminder' },
    { value: 30, viewValue: '30 minutes Before' },
    { value: 60, viewValue: '1 hour Before' },
    { value: 120, viewValue: '2 hours Before' },
    { value: 180, viewValue: '3 hours Before' },
    { value: 240, viewValue: '4 hours Before' },
    { value: 1440, viewValue: '1 day Before' },
    { value: 2880, viewValue: '2 days Before' }
  ]
  timeArray = [

    { hr: 0, min: 0, viewValue: "00 : 00 AM", isDisabledForEndTime: false }, { hr: 0, min: 30, viewValue: " 00 : 30 AM", isDisabledForEndTime: false },
    { hr: 1, min: 0, viewValue: "01 : 00 AM", isDisabledForEndTime: false }, { hr: 1, min: 30, viewValue: "01 : 30 AM", isDisabledForEndTime: false },
    { hr: 2, min: 0, viewValue: "02 : 00 AM", isDisabledForEndTime: false }, { hr: 2, min: 30, viewValue: "02 : 30 AM", isDisabledForEndTime: false },
    { hr: 3, min: 0, viewValue: "03 : 00 AM", isDisabledForEndTime: false }, { hr: 3, min: 30, viewValue: "03 : 30 AM", isDisabledForEndTime: false },
    { hr: 4, min: 0, viewValue: "04 : 00 AM", isDisabledForEndTime: false }, { hr: 4, min: 30, viewValue: "04 : 30 AM", isDisabledForEndTime: false },
    { hr: 5, min: 0, viewValue: "05 : 00 AM", isDisabledForEndTime: false }, { hr: 5, min: 30, viewValue: "05 : 30 AM", isDisabledForEndTime: false },
    { hr: 6, min: 0, viewValue: "06 : 00 AM", isDisabledForEndTime: false }, { hr: 6, min: 30, viewValue: "06 : 30 AM", isDisabledForEndTime: false },
    { hr: 7, min: 0, viewValue: "07 : 00 AM", isDisabledForEndTime: false }, { hr: 7, min: 30, viewValue: "07 : 30 AM", isDisabledForEndTime: false },
    { hr: 8, min: 0, viewValue: "08 : 00 AM", isDisabledForEndTime: false }, { hr: 8, min: 30, viewValue: "08 : 30 AM", isDisabledForEndTime: false },
    { hr: 9, min: 0, viewValue: "09 : 00 AM", isDisabledForEndTime: false }, { hr: 9, min: 30, viewValue: "09 : 30 AM", isDisabledForEndTime: false },
    { hr: 10, min: 0, viewValue: "10 : 00 AM", isDisabledForEndTime: false }, { hr: 10, min: 30, viewValue: "10 : 30 AM", isDisabledForEndTime: false },
    { hr: 11, min: 0, viewValue: "11 : 00 AM", isDisabledForEndTime: false }, { hr: 11, min: 30, viewValue: "11 : 30 AM", isDisabledForEndTime: false },
    { hr: 12, min: 0, viewValue: "12 : 00 PM", isDisabledForEndTime: false }, { hr: 12, min: 30, viewValue: "12 : 30 PM", isDisabledForEndTime: false },
    { hr: 13, min: 0, viewValue: "1 : 00 PM", isDisabledForEndTime: false }, { hr: 13, min: 30, viewValue: "1 : 30 PM", isDisabledForEndTime: false },
    { hr: 14, min: 0, viewValue: "2 : 00 PM", isDisabledForEndTime: false }, { hr: 14, min: 30, viewValue: "2 : 30 PM", isDisabledForEndTime: false },
    { hr: 15, min: 0, viewValue: "3 : 00 PM", isDisabledForEndTime: false }, { hr: 15, min: 30, viewValue: "3 : 30 PM", isDisabledForEndTime: false },
    { hr: 16, min: 0, viewValue: "4 : 00 PM", isDisabledForEndTime: false }, { hr: 16, min: 30, viewValue: "4 : 30 PM", isDisabledForEndTime: false },
    { hr: 17, min: 0, viewValue: "5 : 00 PM", isDisabledForEndTime: false }, { hr: 17, min: 30, viewValue: "5 : 30 PM", isDisabledForEndTime: false },
    { hr: 18, min: 0, viewValue: "6 : 00 PM", isDisabledForEndTime: false }, { hr: 18, min: 30, viewValue: "6 : 30 PM", isDisabledForEndTime: false },
    { hr: 19, min: 0, viewValue: "7 : 00 PM", isDisabledForEndTime: false }, { hr: 19, min: 30, viewValue: "7 : 30 PM", isDisabledForEndTime: false },
    { hr: 20, min: 0, viewValue: "8 : 00 PM", isDisabledForEndTime: false }, { hr: 20, min: 30, viewValue: "8 : 30 PM", isDisabledForEndTime: false },
    { hr: 21, min: 0, viewValue: "9 : 00 PM", isDisabledForEndTime: false }, { hr: 21, min: 30, viewValue: "9 : 30 PM", isDisabledForEndTime: false },
    { hr: 22, min: 0, viewValue: "10 : 00 PM", isDisabledForEndTime: false }, { hr: 22, min: 30, viewValue: "10 : 30 PM", isDisabledForEndTime: false },
    { hr: 23, min: 0, viewValue: "11 : 00 PM", isDisabledForEndTime: false }, { hr: 23, min: 30, viewValue: "11 : 30 PM", isDisabledForEndTime: false },
    { hr: 24, min: 0, viewValue: "12 : 00 AM", isDisabledForEndTime: false }
  ]

  startDate: any
  startTime: any
  callStartTime: any
  filteredStartTimeArray: any[] = [];
  filteredEndTimeArray: any[] = [];
  filteredTimeArray: any[] = [];


  getStartTime(date: any) {
    let d = new Date(date);
    let hours = d.getHours();
    let min = d.getMinutes();
    this.timeArray.forEach((element: any) => {
      if (element.hr === hours && element.min === min) {
        this.callStartTime = element.viewValue
        //  
      }
    })
  }

  leadDetails: any;
  getLeadDetails(leadId: any) {
    if (!leadId)
      return;
    this.crmService.getLeadById(leadId).subscribe(
      {
        next: (response: any) => {
          this.leadDetails = response.data;
          this.meetDetails['leadMail'] = this.leadDetails?.personalInfo?.email;
          this.meetDetails.pipeline = this.leadDetails.pipeline;
          this.meetDetails.pipelineStage = this.leadDetails.pipelineStage;
          if ((this.data.data.type == 'MEETINGS' || this.data.data.type == 'ACTIVITY' || this.data.data.type == 'ALL_MEETINGS') && !this.data.data.edit) {
            this.meetDetails.leadName = this.leadDetails?.personalInfo?.name;
            this.meetDetails.leadId = this.leadDetails?.id;
            this.meetDetails.leadNumber = this.leadDetails?.personalInfo?.mobile
            // this.meetDetails.locationType = this.data.data.data?.storeId ? 'BUSINESS_LOCATION' : 'CLIENT_LOCATION';
            // if (this.meetDetails.locationType == 'BUSINESS_LOCATION') {
            //   this.fetchStores();
            // }

            this.meetDetails.participantsList.push(
              {
                leadId: this.leadDetails.id,
                leadMail: this.leadDetails?.personalInfo?.email ?? "",
                companyName: this.leadDetails?.personalInfo?.companyName || 'N/A',
                leadName: this.leadDetails.personalInfo.name
              }
            )
            this.originalStartDate = new Date(this.meetDetails.startDateTime);
          }

          let prefillPipelineId = '';
          let prefillStageId = '';
          if (this.selectedContact) {
            const leadDetails = this.leadDetails;
            prefillPipelineId = leadDetails?.pipeline?.id || '';
            prefillStageId = leadDetails?.pipelineStage?.id || '';
          }
          // ⚪ Case 3: Create directly from Module
          else {
            prefillPipelineId = '';
            prefillStageId = '';
          }

          // --- Prefill if available ---
          if (prefillPipelineId) {
            this.selectedPipelineId = prefillPipelineId;

            const selectedPipeline = this.listPipelines.find(
              (pipeline) => pipeline.id === this.selectedPipelineId
            );

            if (selectedPipeline) {
              this.pipelineStages = selectedPipeline.stages || [];
              this.pipelineSelected = true;

              if (prefillStageId) {
                this.selectedStageId = prefillStageId;
              }
            }
          } else {
            // Reset state if none
            this.selectedPipelineId = '';
            this.selectedStageId = '';
            this.pipelineStages = [];
            this.pipelineSelected = false;
          }

          this.leadDetails.fieldMap = {};
          this.leadIdPipelineId = this.leadDetails?.pipeline?.id
          if (this.leadDetails.staffName && this.leadDetails.staffId) {
            const { staffName, staffId, pipeline } = this.leadDetails;
            this.filteredStaffList.push({ name: staffName, id: staffId });
            this.meetDetails.assignedTo = staffId;
            if (this.data.data.edit) {
              this.meetDetails.assignedTo = this.data.data.data.assignedTo;
            }
            const matchPipeline = this.listPipelines.find(p => p.id === pipeline?.id);
            if (matchPipeline?.assignedStaff) {
              const otherStaff = matchPipeline.assignedStaff
                .filter((staff: any) => staff.id !== staffId)
                .map((staff: any) => ({ name: staff.name, id: staff.id }));
              this.filteredStaffList.push(...otherStaff);
              this.staffList = this.filteredStaffList;
            }
          }
        },
        error: (err: any) => {
        }
      }
    )
  }
  staffList: any = [];
  getStaffListing() {
    this.staffAccessService.getAssignStaffListing(this.dbService.getBusinessId(), this.pageNo, this.size, '').subscribe({
      next: (res: any) => {
        this.staffList = res.data.data;
        this.filteredStaffList = this.staffList;
      },
      error: (err: any) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )
      }
    })
  }
  changeStaff() {
    for (let ele of this.staffList) {
      if (ele.id === this.meetDetails.assignedTo) {
        this.meetDetails.assignToMailId = ele?.contact?.email;
        this.meetDetails.assignedName = ele.name;

        break;
      }
    };
  }

  staffSearch: string = '';
  filteredStaffList: any[] = [];


  filterStaff() {
    const search = this.staffSearch.toLowerCase();
    this.filteredStaffList = this.staffList.filter(staff =>
      staff.name.toLowerCase().includes(search)
    );

    this.pipelineBasedStaff.get(this.leadIdPipelineId).filteredStaff = this.pipelineBasedStaff.get(this.leadIdPipelineId)?.staff?.filter(staff =>
      staff.name.toLowerCase().includes(search)
    );
  }
  getEndTime(date: any) {
    let d = new Date(date);
    let hours = d.getHours();
    let min = d.getMinutes();
    this.timeArray.forEach((element: any) => {
      if (element.hr === hours && element.min === min) {
        this.callEndTime = element.viewValue
        //  
      }
    })
  }
  setStartTime() {
    if (this.allDayCheckbox) {
      const endTimeObj = this.filteredEndTimeArray.find(
        (item: any) => item.hr === 23 && item.min === 30
      );

      if (endTimeObj) {
        this.callEndTime = endTimeObj.viewValue;
      }
      const startDate = new Date(this.meetDetails.startDateTime);
      const endDate = new Date(startDate);
      endDate.setHours(23, 30, 0, 0);
      this.meetDetails.endDateTime = new Date(endDate);
    } else {
      this.callEndTime = null;
      this.meetDetails.endDateTime = null;
    }
  }
  endDate: any
  endTime: any
  callEndTime: any
  setEndTime() {
    this.timeArray.forEach((item: any) => {
      if (item.viewValue === this.callEndTime) {
        this.endDate = new Date(this.meetDetails.endDateTime);
        this.endTime = this.endDate.setHours(item.hr, item.min);
        this.meetDetails.endDateTime = new Date(this.endTime);
        // 
      }
    })
  }
  allDayCheckbox: boolean = false;

  changeMeetingType() {
    if (this.meetDetails.meetingType === 'VIRTUAL') {
      this.meetDetails.meetingLocated = '';
    } else {
      this.meetDetails.meetingLink = '';
    }
  }
  meetDetails: any = {
    businessId: this.dbService.getBusinessId(),
    leadId: "",
    leadName: "",
    leadNumber: "",
    leadMail: "",
    title: "Store Visit",
    meetingType: 'PHYSICAL',
    meetingLocated: "",
    meetingLink: "",
    startDateTime: "",
    endDateTime: "",
    meetingStatus: "NEW",
    remainder: 0,
    participantsList: [],
    emailData: [],
    participantsRemainder: 0,
    description: "",
    // createdTimeStamp: new Date(),
    // updatedTimeStamp: new Date(),
    createdById: localStorage.getItem(StorageKeys.STAFF_ID),
    createdByName: localStorage.getItem(StorageKeys.STAFF_NAME),
    pipeline: {
      id: "",
      name: ""
    },
    pipelineStage: {
      id: "",
      name: ""
    },
    storeId: "",
    storeName: "",
    locationType: "BUSINESS_LOCATION",
  };
  addLoader: boolean = false;
  createLoader: boolean = false;

  recordMeeting() {
    this.meetDetails.meetingStatus = "IN_PROGRESS";
    this.meetDetails.birthday = this.datePipe.transform(this.meetDetails.birthday, 'dd-MM-yyyy');
    this.meetDetails.anniversary = this.datePipe.transform(this.meetDetails.anniversary, 'dd-MM-yyyy');
    this.createMeet();
  }
  createMeet() {
    this.createLoader = true
    // this.meetDetails.startDateTime.setDate(this.meetDetails.startDateTime.getDate() + 1);
    // this.meetDetails.startDateTime.setHours(this.meetDetails.startDateTime.getHours() + 5);
    // this.meetDetails.startDateTime.setMinutes(this.meetDetails.startDateTime.getMinutes() + 30);
    if (this.meetDetails.startDateTime) {
      this.meetDetails.startDateTime = this.appendTimeToDate(this.meetDetails.startDateTime, this.callStartTime);
    }
    if (this.meetDetails.endDateTime) {
      this.meetDetails.endDateTime = this.appendTimeToDate(this.meetDetails.endDateTime, this.callEndTime);
    }

    if (this.isStaffAdmin) {
      this.pipelineBasedStaff.get(this.leadIdPipelineId)?.staff?.forEach((staff: any) => {
        if (staff.id === this.meetDetails.assignedTo) {
          this.meetDetails.assignToMailId = staff?.contact?.email;
          this.meetDetails.assignedName = staff.name;
        }
      });
    }

    this.options.forEach(element => {
      if (this.meetDetails.leadId == element.id) {
        this.meetDetails.pipeline.id = element.pipeline.id;
        this.meetDetails.pipeline.name = element.pipeline.name;
      }
    });

    if (!this.isStaffAdmin) {
      this.meetDetails.assignedTo = localStorage.getItem(StorageKeys.STAFF_ID) || '';
      this.meetDetails.assignedName = localStorage.getItem(StorageKeys.STAFF_NAME) || '';
      this.meetDetails.assignToMailId = localStorage.getItem(StorageKeys.STAFF_EMAIL) || '';
    }

    this.crmService.createMeeting(this.meetDetails).pipe(
      switchMap((res: any) => {
        const targetId = res?.data?.id || res?.data?.meetingId;
        return this.assignLabelsAfterSave(targetId, res).pipe(map((labelWarning) => labelWarning));
      })
    ).subscribe(
      (labelWarning: string | null) => {
        this.dialogRef.close("success");
        this.snackBar.open(labelWarning || 'Meeting has been created successfully', 'Close', { duration: labelWarning ? 3500 : 1500 });
        this.createLoader = false;
      },
      (err) => {
        if (err.error.errorCode) {
          this.crmService.openSocialBrand(PricingDetailsComponent, '100vh', '100%', {})
        }
        this.createLoader = false
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )
      }
    )
  }
  cancel() {
    this.dialogRef.close()
  }
  originalStartDate: Date | null = null;
  editMeet() {
    this.createLoader = true;
    // this.meetDetails.startDateTime.setHours(this.meetDetails.startDateTime.getHours() + 5);
    // this.meetDetails.startDateTime.setMinutes(this.meetDetails.startDateTime.getMinutes() + 30);
    // this.meetDetails.endDateTime.setHours(this.meetDetails.endDateTime.getHours() + 5);
    // this.meetDetails.endDateTime.setMinutes(this.meetDetails.endDateTime.getMinutes() + 30);
    // Only apply logic if in edit mode
    if (this.data?.data?.edit === true && this.meetDetails.startDateTime) {
      this.meetDetails.startDateTime = this.appendTimeToDate(this.meetDetails.startDateTime, this.callStartTime);
    }

    if (this.data?.data?.edit === true && this.meetDetails.endDateTime) {
      this.meetDetails.endDateTime = this.appendTimeToDate(this.meetDetails.endDateTime, this.callEndTime);
    } else {
      this.meetDetails.endDateTime = "";
    }

    this.options.forEach(element => {
      if (this.meetDetails.leadId == element.id) {
        this.meetDetails.pipeline.id = element.pipeline.id;
        this.meetDetails.pipeline.name = element.pipeline.name;
      }
    });

    if (this.isStaffAdmin) {
      this.pipelineBasedStaff.get(this.leadIdPipelineId)?.staff?.forEach((staff: any) => {
        if (staff.id === this.meetDetails.assignedTo) {
          this.meetDetails.assignToMailId = staff?.contact?.email;
          this.meetDetails.assignedName = staff.name;
        }
      });
    }

    if (!this.isStaffAdmin) {
      this.meetDetails.assignedTo = localStorage.getItem(StorageKeys.STAFF_ID) || '';
      this.meetDetails.assignedName = localStorage.getItem(StorageKeys.STAFF_NAME) || '';
      this.meetDetails.assignToMailId = localStorage.getItem(StorageKeys.STAFF_EMAIL) || '';
    }



    this.crmService.editMeeting(this.meetDetails).pipe(
      switchMap((res: any) => {
        const targetId = res?.data?.id || this.meetDetails?.id;
        return this.assignLabelsAfterSave(targetId, res).pipe(map((labelWarning) => labelWarning));
      })
    ).subscribe(
      (labelWarning: string | null) => {
        this.snackBar.open(labelWarning || 'Meeting has been updated successfully', 'Close', { duration: labelWarning ? 3500 : 1500 });
        this.createLoader = false;
        this.dialogRef.close("success");
      },
      (err) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )

        this.createLoader = false;
      }
    )

  }

  appendTimeToDate(dateValue: Date, time12hr: string): string {
    if (!dateValue || !time12hr) return '';

    const date = new Date(dateValue);

    const yyyy = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    const [timePart, ampm] = time12hr.trim().split(' PM').length > 1
      ? [time12hr.replace(' PM', ''), 'PM']
      : [time12hr.replace(' AM', ''), 'AM'];

    const [h, m] = timePart.split(' : ');

    let hour = Number(h);
    const minute = Number(m);

    if (ampm === 'PM' && hour < 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;

    const HH = String(hour).padStart(2, '0');
    const mm = String(minute).padStart(2, '0');
    const ss = '00';

    return `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}`;
  }




  searchResults: any;
  searchBox = new FormControl();
  locations: any = [];
  search() {
    this.mapService.searchAddress(this.meetDetails.meetingLocated).subscribe(
      (res: any) => {
        let locations: any = [];
        res.features.forEach((location: any) => {
          locations.push({
            displayName:
              location?.place_name.split(', ')[0] +
              ',' +
              location?.context[0]?.text +
              ',' +
              location?.context[2]?.text,
            latlng: location?.center,
          });
        });
        this.locations = locations;
        this.searchResults = this.searchBox.valueChanges.pipe(
          startWith(''),
          map((value) => this._searchFilter(value))
        );
      },
    );
  }

  private _searchFilter(value: any) {
    const filterValue = value.toLowerCase();

    return this.locations.filter((option: any) =>
      option.displayName.toLowerCase().includes(filterValue)
    );
  }

  selectedLocation: any;
  selectedLocations(option: any) {
    this.selectedLocation = option;
    let splitedLocation = this.selectedLocation.displayName.split(',');
    localStorage.setItem(StorageKeys.LOCALITY, splitedLocation[0])
    localStorage.setItem(StorageKeys.STATE, splitedLocation[1]);
  }


  addParticipants() {
    let dialog = this.crmService.openServiceDialog(
      AddMeetingParticipantsComponent,
      '100vh',
      this.screenWidth > 475 ? '36%' : '100%',
      '100vw',
      { participantsList: this.meetDetails?.participantsList ?? [], emailData: this.meetDetails?.emailData ?? [], type: 'Create' }
    );
    dialog.afterClosed().subscribe((res: any) => {
      if (!res) return;

      this.meetDetails.emailData = res.emailData ?? [];
      this.meetDetails.participantsList = res.participantList ?? [];
      // 
    });
  }

  getContacts() {
    this.crmService.searchLeadsCustomers(this.dbService.getBusinessId(), 0, 50, this.participantType, this.selectedContact).subscribe(
      (res: any) => {
        this.options = [];
        this.options = res.data.data;

        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '')),
        );
      },
      (err) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          { duration: 1500 }
        )
      }
    )
  }

  // for the leads and customer filter
  pageNo = 0;
  size = 100000;
  getdata() {

    this.crmService.getLeadApis(this.dbService.getBusinessId(), this.pageNo, this.size, this.participantType, status, !this.isStaffAdmin ? localStorage.getItem(StorageKeys.STAFF_ID) : '').subscribe(
      (res: any) => {
        this.options = res.data.data;

        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '')),
        );
      },
      (err) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          { duration: 1500 }
        )
      }
    )
  }
  contactSelected(contactData: any) {
    this.selectedContact = contactData?.personalInfo?.name;
    this.myControl.setValue(contactData?.personalInfo?.name, { emitEvent: false });
    this.leadIdPipelineId = contactData?.pipeline?.id
    this.meetDetails.leadName = contactData?.personalInfo?.name;
    this.meetDetails.leadNumber = contactData?.personalInfo?.mobile
    this.meetDetails.leadId = contactData.id;
  }
  closeparticipant(i: number, isLeadOrCustomer: boolean) {
    if (isLeadOrCustomer) {
      this.meetDetails.participantsList.splice(i, 1);
    } else {
      this.meetDetails.emailData.splice(i, 1);
    }
  }
  onEndTimeChange() {
    if (this.meetDetails.endDateTime && this.callEndTime) {
      const dateMoment = moment(this.meetDetails.endDateTime);
      let time = this.callEndTime.trim();
      if (time.toLowerCase().includes('am') || time.toLowerCase().includes('pm')) {
        time = moment(time, ['hh:mm A']).format('HH:mm');
      }
      const [hours, minutes] = time.split(':').map(Number);
      dateMoment.set({
        hour: hours,
        minute: minutes,
        second: 0,
        millisecond: 0
      });
      this.meetDetails.endDateTime = dateMoment.toDate();
    }
  }

  getMeetingById() {
    this.crmService.getMeetingDetails(this.data.data.meetId).subscribe(
      (res: any) => {
        this.meetDetails = res.data;
        this.meetDetails.locationType = this.meetDetails.storeId ? 'BUSINESS_LOCATION' : 'CLIENT_LOCATION';
        if (this.meetDetails.locationType == 'BUSINESS_LOCATION') {
          this.fetchStores();
        }
        this.getStartTime(this.meetDetails.startDateTime);
        this.getEndTime(this.meetDetails.endDateTime)
        this.selectedLabelIds = [...(this.meetDetails?.labelIds || [])];
        this.selectedLabels = [...(this.meetDetails?.labels || [])];
        // 
      }
    )
  }

  onSelectedLabelIdsChange(ids: string[]): void {
    this.selectedLabelIds = [...(ids || [])];
  }

  onSelectedLabelsChange(labels: CrmLabel[]): void {
    this.selectedLabels = [...(labels || [])];
  }

  /** Returns null on success, or a human-readable warning string if labels could not be attached. */
  private assignLabelsAfterSave(targetId: string | undefined, rawResponse?: any): Observable<string | null> {
    if (!targetId) {
      if ((this.selectedLabelIds || []).length) {
        console.warn('Label assignment skipped: could not resolve target id from save response.', rawResponse);
        return of('Meeting saved, but labels could not be attached (missing meeting id). Please re-open and re-apply labels.');
      }
      return of(null);
    }
    const businessId = localStorage.getItem('businessId') || '';
    return this.crmService.assignLabels({
      businessId,
      targetType: 'MEETING',
      targetId,
      labelIds: this.selectedLabelIds || []
    }).pipe(
      map(() => null),
      catchError((err) => {
        console.warn('Label assignment request failed.', err);
        return of(err?.error?.message || 'Meeting saved, but labels could not be updated');
      })
    );
  }

  clipboard: boolean = false;
  clipboardCopy(text: any) {
    navigator.clipboard.writeText(text);
    this.templateService.openSnack("link copied successfully", "Close")
  }

  filterEndTime() {
    const startDateTime = new Date(this.meetDetails.startDateTime);
    const endDateTime = new Date(this.meetDetails.endDateTime);
    if (startDateTime.setHours(0, 0, 0) === endDateTime.setHours(0, 0, 0)) {
      this.timeArray.forEach((time) => {
        time.isDisabledForEndTime = (time.viewValue < this.callStartTime);
      })
    } else {
      this.timeArray.forEach((time) => {
        time.isDisabledForEndTime = false;
      })
    }
  }
  filterTimes() {
    const now = new Date();
    const selectedStartDate = new Date(this.meetDetails.startDateTime);
    this.filteredStartTimeArray = this.timeArray.map(time => {
      const itemDate = new Date(selectedStartDate);
      itemDate.setHours(time.hr, time.min);
      const isPastTime = itemDate < now;
      return { ...time, isDisabled: isPastTime };
    });
    this.filterEndTimes();
  }

  filterEndTimes() {
    const selectedStartDate = new Date(this.meetDetails.startDateTime);
    const selectedEndDate = new Date(this.meetDetails.endDateTime);
    const isSameDay = selectedStartDate.toDateString() === selectedEndDate.toDateString();
    const startTime = this.timeArray.find(t => t.viewValue === this.callStartTime);

    this.filteredEndTimeArray = this.timeArray.map(time => {
      if (isSameDay && startTime) {
        const isBeforeOrEqualStart = time.hr < startTime.hr || (time.hr === startTime.hr && time.min <= startTime.min);
        return { ...time, isDisabled: isBeforeOrEqualStart };
      } else {
        return { ...time, isDisabled: false };
      }
    });
  }

  onStartDateChange() {
    this.filterTimes();
    if (this.meetDetails.endDateTime &&
      this.meetDetails.endDateTime < this.meetDetails.startDateTime) {
      this.meetDetails.endDateTime = null;
    }
    // Auto-select the first available start time
    const firstAvailableStartTime = this.filteredStartTimeArray.find(t => !t.isDisabled);
    if (firstAvailableStartTime) {
      this.callStartTime = firstAvailableStartTime.viewValue;
    } else {
      this.callStartTime = '';
    }
    this.meetDetails.endDateTime = new Date(this.meetDetails.startDateTime);
    this.filterEndTimes();
    const startIndex = this.filteredEndTimeArray.findIndex(t => t.viewValue === this.callStartTime);
    if (startIndex !== -1) {
      const nextSlot = this.filteredEndTimeArray.slice(startIndex + 1).find(t => !t.isDisabled);
      this.callEndTime = nextSlot ? nextSlot.viewValue : '';
    } else {
      this.callEndTime = '';
    }
    if (this.data?.data?.edit) {
      const newStart = new Date(this.meetDetails.startDateTime);
      if (this.originalStartDate && newStart.getTime() !== this.originalStartDate.getTime()) {
        this.meetDetails.endDateTime = new Date(this.meetDetails.startDateTime);
        this.callEndTime = '';
      }
    }
  }


  onStartTimeChange() {
    if (this.meetDetails.startDateTime && this.callStartTime) {
      const dateMoment = moment(this.meetDetails.startDateTime);
      let time = this.callStartTime.trim();
      if (time.toLowerCase().includes('am') || time.toLowerCase().includes('pm')) {
        time = moment(time, ['hh:mm A']).format('HH:mm');
      }

      const [hours, minutes] = time.split(':').map(Number);
      dateMoment.set({
        hour: hours,
        minute: minutes,
        second: 0,
        millisecond: 0
      });
      this.meetDetails.startDateTime = dateMoment.toDate();
    }

    this.filterEndTimes();

    if (this.filteredEndTimeArray.find(t => t.viewValue === this.callEndTime)?.isDisabled) {
      this.callEndTime = '';
    }
  }
  public onEndDateChange(): void {
    if (this.meetDetails.endDateTime) {
      const localDate = new Date(this.meetDetails.endDateTime);
      const checkStartDate = new Date(this.meetDetails.startDateTime);
      localDate.setHours(0, 0, 0, 0);
      checkStartDate.setHours(0, 0, 0, 0);
      if (localDate.getTime() === checkStartDate.getTime()) {
        this.filterEndTimes();

        const startIndex = this.filteredEndTimeArray.findIndex(
          t => t.viewValue === this.callStartTime
        );

        if (startIndex !== -1) {
          const nextSlot = this.filteredEndTimeArray
            .slice(startIndex + 1)
            .find(t => !t.isDisabled);
          this.callEndTime = nextSlot ? nextSlot.viewValue : '';
        } else {
          this.callEndTime = '';
        }
      }
      else {
        this.filterEndTimes();
        localDate.setHours(0, 0, 0, 0);
        this.meetDetails.endDateTime = localDate;
        const availableTime = this.filteredEndTimeArray.find(t => !t.isDisabled);
        if (availableTime) {
          this.callEndTime = availableTime.viewValue;
        } else {
          this.callEndTime = '';
        }
      }
    }
  }

  pipelineBasedStaff: Map<String, any> = new Map();

  getAllPipelines() {
    const businessId = localStorage.getItem('businessId');
    const staffId = localStorage.getItem('staffId');

    this.crmService.getListPipelines(businessId, staffId, true).subscribe((res: any) => {
      this.listPipelines = res.data || [];

      this.allocatedPipelineBasedStaff();

      let prefillPipelineId = '';
      let prefillStageId = '';

      // 🟢 Case 1: Edit mode
      if (this.data.data?.edit && this.meetDetails?.pipeline?.id) {
        prefillPipelineId = this.meetDetails.pipeline.id;
        prefillStageId = this.meetDetails.pipelineStage?.id || '';
      }
    });
  }

  allocatedPipelineBasedStaff() {
    this.listPipelines.forEach((pipeline: any) => {
      this.pipelineBasedStaff.set(pipeline.id, {
        staff: [...pipeline.assignedStaff],
        filteredStaff: [...pipeline.assignedStaff]
      });
    })
  }

  onPipelineChange() {
    const selectedPipeline = this.listPipelines.find(
      (pipeline) => pipeline.id === this.selectedPipelineId
    );

    if (selectedPipeline) {
      this.pipelineStages = selectedPipeline.stages || [];
      this.pipelineSelected = true;

      // Update meeting details
      this.meetDetails.pipeline = {
        id: selectedPipeline.id,
        name: selectedPipeline.name
      };

      // Reset stage if not in edit mode
      if (!this.data.data?.edit) {
        this.selectedStageId = '';
        this.meetDetails.pipelineStage = { id: '', name: '' };
      }
    }
  }

  onStageChange() {
    const selectedStage = this.pipelineStages.find(
      (stage) => stage.id === this.selectedStageId
    );

    if (selectedStage) {
      this.meetDetails.pipelineStage = {
        id: selectedStage.id,
        name: selectedStage.name
      };
    }
  }

  setScheduleDateTime() {
    if (!this.startDate || !this.callStartTime) {
      return;
    }

    // Clone date
    const date = new Date(this.startDate);

    // Parse time like "02:00 PM"
    const [time, meridian] = this.callStartTime.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    // Convert to 24-hour format
    if (meridian === 'PM' && hours !== 12) hours += 12;
    if (meridian === 'AM' && hours === 12) hours = 0;

    date.setHours(hours, minutes, 0, 0);

    // Build IST datetime string (NO UTC)
    const istDateTimeString = this.buildISTString(date);

    // Send THIS to backend
    this.meetDetails.startDateTime = istDateTimeString;
  }

  setEndDateime() {
    if (!this.endDate || !this.callEndTime) {
      return;
    }

    // Clone date
    const date = new Date(this.endDate);

    // Parse time like "02:00 PM"
    const [time, meridian] = this.callEndTime.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    // Convert to 24-hour format
    if (meridian === 'PM' && hours !== 12) hours += 12;
    if (meridian === 'AM' && hours === 12) hours = 0;

    date.setHours(hours, minutes, 0, 0);

    // Build IST datetime string (NO UTC)
    const istDateTimeString = this.buildISTString(date);

    // Send THIS to backend
    this.meetDetails.endDateTime = istDateTimeString;
  }

  buildISTString(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');

    // ⛔ NO timezone
    return `${y}-${m}-${d}T${h}:${min}:00`;
  }

  storeList: any[] = [];

  requestBody: any = {
    businessId: localStorage.getItem('businessId'),
    pageNo: 0,
    pageSize: 1000000
  };

  fetchStores(): void {
    this.requestBody.pageNo = 0;
    this.requestBody.pageSize = 1000000;

    this.ecommerceService.fetchStoreList(this.requestBody).subscribe({
      next: (response: any) => {
        this.storeList = response.data.data;
        this.meetDetails.storeId = this.storeList.length === 1 ? this.storeList[0].id : null;
        this.meetDetails.storeName = this.storeList.length === 1 ? this.storeList[0].storeName : null;
        this.meetDetails.meetingLocated = '';
        if (this.data.data?.edit && this.data.data.type === 'ALL_MEETINGS') {
          this.meetDetails.storeId = this.data.data.data?.storeId;
          this.meetDetails.storeName = this.data.data.data?.storeName;
        }
      },
      error: (err) => {
      }
    });
  }

  changeLocationType() {
    if (this.meetDetails.locationType === 'CLIENT_LOCATION') {
      this.meetDetails.storeId = '';
      this.meetDetails.storeName = '';
    }
    else {
      this.fetchStores();
      this.meetDetails.meetingLocated = '';
    }
  }

  onStoreChange() {
    this.storeList.forEach(store => { if (store.id === this.meetDetails.storeId) { this.meetDetails.storeName = store.storeName; } })
  }

  visitTypeValidation() {
    if (this.meetDetails.meetingType === 'VIRTUAL') {
      if (!this.meetDetails.meetingLink) {
        return true;
      }
    }
    if (this.meetDetails.meetingType === 'PHYSICAL') {
      if (this.meetDetails.locationType === 'BUSINESS_LOCATION' && !this.meetDetails.storeId) {
        return true;
      }
      if (this.meetDetails.locationType === 'CLIENT_LOCATION' && !this.meetDetails.meetingLocated) {
        return true;
      }
    }

    if (this.meetDetails.leadId == '' || this.meetDetails.leadId == null || this.meetDetails.leadId == undefined) {
      return true;
    }

    return false;
  }
}
